/* eslint-disable no-underscore-dangle */
import { checkHasPermissions } from '../../utils';

import permissions from '../../permissions';

export const getVerificationData = (user) => {
  const { firstName, lastName } = user || {};
  const { accessAdmin } = permissions;
  const hasAdminAccess = checkHasPermissions(accessAdmin, user);
  return { firstName, lastName, hasAdminAccess };
};

export const validateSetPassword = (values) => {
  const errors = {};
  if (values.password !== values.confirmPassword) {
    errors.password = 'Password fields must match';
    errors.confirmPassword = 'Password fields must match';
  }
  errors._error = values.token
    ? null
    : values.password
    ? 'A token is required to set your password'
    : null;
  return errors;
};
